import React, { Component, ChangeEvent } from 'react';
import { TRequestStatus } from '../../../../common/types/RequestStatus';
import { Link } from 'react-router-dom';
import { ChangeSortBy } from '../../../../common/helpers/Sorting';
import TableSort from '../../../../common/helpers/TableSort';
import ToolbarControls from '../../../generics/Header/ToolbarControls';
import SortButton from '../../../utils/SortButton/SortButton';
import { getFilteredItems } from '../../../../common/helpers/Filter';
import GhostButtonControl from '../../../controls/GhostButtonControl/GhostButtonControl';
import ToggleControl from '../../../controls/ToggleControl/ToggleControl';
import TextControl from '../../../controls/TextControl/TextControl';
import { listElectricityUtils } from '../../../../common/api/endpoints/electricityUtils';
import BreadcrumbControls from '../../../generics/Header/BreadcrumbControls';
import { withTransitionEvent } from '../../../TransitionEvent';
import ElectricityUtilDTO from '../../../../common/api/dtos/ElectricityUtil';
import moment from 'moment';

interface State {
  electricityUtils?: ElectricityUtilDTO[],
  status: TRequestStatus
  tableSort: TableSort,
  showDeleted: boolean,
  filterValue: string,
}

class ElectricityUtilList extends Component<{}, State> {
  availableFilters: string[] = [
    'code',
    'description',
  ];

  constructor(props: {}) {
    super(props);
    this.state = {
      status: 'loading',
      tableSort: new TableSort('code', 'asc'),
      showDeleted: localStorage.getItem('showDeletedEvents') === 'false' || localStorage.getItem('showDeletedEvents') === null ? false : true,
      filterValue: '',
    }
  }

  toggleDisabled = (electricityUtil: ChangeEvent<HTMLInputElement>) => {
    localStorage.setItem(electricityUtil.target.name, JSON.stringify(electricityUtil.target.checked));
    this.state.showDeleted ? this.setState({showDeleted: false}) : this.setState({showDeleted: true});
  }

  fetchEvents = async () => {
    this.setState({
      status: 'loading'
    });
    
    const electricityUtils = await listElectricityUtils();

    this.setState({
        status: 'success',
        electricityUtils: electricityUtils,
    });
  }
  
  handleSortChange = (column: string) => {
    this.setState((prevState: State) => {
      return { 
        tableSort: ChangeSortBy(column, prevState.tableSort.sortBy, prevState.tableSort.sortDirection),
       };
    });
  }

  setFilterValue = (ev: ChangeEvent<HTMLInputElement>) => {
    this.setState({
      filterValue: ev.target.value,
    })
  }

  componentDidMount() {
    this.fetchEvents();
  }

  renderTHeadRow() {
    return (
      <tr>
        <th>#</th>
        <th className="text-left">
          <SortButton 
            column='code' 
            text='Invoice Code'
            tableSort={this.state.tableSort}
            onClick={this.handleSortChange}
          ></SortButton>
        </th>
        <th className="text-left">
          <SortButton 
            column='date' 
            text='Date'
            tableSort={this.state.tableSort}
            onClick={this.handleSortChange}
          ></SortButton>
        </th>
        <th className="text-left">
          <SortButton 
            column='description' 
            text='Description'
            tableSort={this.state.tableSort}
            onClick={this.handleSortChange}
          ></SortButton>
        </th>
        <th className="text-center">
          <SortButton 
            column='quantity' 
            text='Quantity'
            tableSort={this.state.tableSort}
            onClick={this.handleSortChange}
          ></SortButton>
        </th>
        <th className="text-center">
          <SortButton 
            column='amount' 
            text='Amount'
            tableSort={this.state.tableSort}
            onClick={this.handleSortChange}
          ></SortButton>
        </th>
        <th className="text-center">
          <SortButton 
            column='amountPerUnit' 
            text='PPU '
            tableSort={this.state.tableSort}
            onClick={this.handleSortChange}
          ></SortButton>
        </th>
        <th></th>
      </tr>
    )
  }

  renderTBodyRow(electricityUtil: ElectricityUtilDTO) {
    return (
      <tr id={`electricityUtil${electricityUtil.id}`} key={`${electricityUtil.id}`}>
        <td></td>
        <td>
          <span>{electricityUtil.code}</span>
        </td>
        <td>
          <span>{moment(electricityUtil.date).format('MMMM, YYYY')}</span>
        </td>
        <td>
          <p className="text-chunk">{electricityUtil.description}</p>
        </td>
        <td className="text-center">
          <span>{electricityUtil.quantity}</span>
        </td>
        <td className="text-center">
          <span>{electricityUtil.amount}</span>
        </td>
        <td className="text-center">
          <span>{electricityUtil.amountPerUnit}</span>
        </td>
        <td className="text-right">
          <GhostButtonControl to={`/electricity/edit/${electricityUtil.id}`} class="ghost-button" icon="fas fa-angle-right"></GhostButtonControl>
        </td>
      </tr>
    );
  }

  render() {
    const filteredEvents: Array<ElectricityUtilDTO> = getFilteredItems(this.state.filterValue, this.availableFilters, this.state.electricityUtils ? this.state.electricityUtils : []).sort(this.state.tableSort.sortByColumn).filter((electricityUtil: ElectricityUtilDTO) => electricityUtil.deleted === this.state.showDeleted);
    return (
      <>
        <BreadcrumbControls
          pageTitle="Electricity"
          status={this.state.status}
        />
        {this.state.electricityUtils && 
          <div>
            <div className="flex-row fill">
              <div className="column">
                <ToolbarControls>
                  <TextControl
                    label="Filter"
                    placeholder="Filter"
                    type="text"
                    name="filterBox"
                    id="filterBox"
                    onChange={this.setFilterValue}
                    srOnly={true}
                  />
                  <ToggleControl
                    id="showDeletedEvents"
                    name="showDeletedEvents"
                    changeMethod={this.toggleDisabled}
                    isChecked={this.state.showDeleted}
                    labelText="Recycle bin"
                    icon="fas fa-trash-undo"
                    srOnly={true}
                    title="Recyle bin"
                  />
                  <div className="form-group">
                    <Link to='/electricity/add' className="primary-button"><span className="static-icon"><span className="fas fa-plus-circle"></span></span> <span className="text">Add record</span></Link>
                  </div>
                </ToolbarControls>

                <div className="flex-row squeeze flex-v-center">
                  <div className="column">
                      <img className="thumbnail large release" style={{backgroundColor: 'transparent', imageRendering: 'auto'}} src="/assets/icons/electricity.png" />
                  </div>
                  <div className="column">
                      <div className="card">
                          <h2 className="primary-title">averages</h2>
                          <br />
                          <span className="faint-text">900 kWh / mo | 10.8 MWh / yr</span>
                      </div>
                  </div>
                  <div className="column">
                      <span className="faint-text">Up next</span>
                      <br />
                      <h2 className="primary-title">890 kWh at 540.00 lei</h2>
                      <br />
                      <small className="faint-text">Predicted electricity consumption for December, 2022</small>
                  </div>
                </div>
                <div className="flex-row fill">
                  <div className="column">
                    <div className="tableview-component">
                        <div className={`
                            card
                            ${!this.state.electricityUtils ? 'loader-border' : ''}
                            ${this.state.showDeleted ? "flashing-border" : ""}
                          `}
                        >
                        <table>
                          <thead>
                            {this.renderTHeadRow()}
                          </thead>
                          {this.state.electricityUtils &&
                            <React.Fragment>
                              <tbody>
                                {filteredEvents.map(electricityUtil => (
                                  this.renderTBodyRow(electricityUtil)
                                ))}
                              </tbody>
                              <tfoot>
                                {this.state.electricityUtils?.length === 0 &&
                                  <tr>
                                    <th colSpan={8}>
                                      <div className="card">
                                        <p className="text-chunk">There are no electricity records defined. Start by <Link className="link-button" to="/electricity/add">adding</Link> the first one.</p>
                                      </div>
                                    </th>
                                  </tr>
                                }
                                {this.state.filterValue &&
                                  <tr>
                                    <th colSpan={8}>
                                      <div className="card">
                                        <p className="text-chunk">Showing {filteredEvents.length} out of {this.state.electricityUtils.filter((electricityUtil: ElectricityUtilDTO) => electricityUtil.deleted === this.state.showDeleted).length} results.</p>
                                      </div>
                                    </th>
                                  </tr>
                                }
                              </tfoot>
                            </React.Fragment>
                          }
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </>
    );
  }
}

export default withTransitionEvent(ElectricityUtilList);